<template>
    <div class="search-wrapper-real" style="display:none">
        <!-- 搜索框 -->
        <form action="/">
            <van-search
                v-model="inputKeyword"
                placeholder="搜索你感兴趣的试试"
                show-action
                @search="searchKeywords"
                @cancel="searchCancel"
            />
        </form>
        <!-- 历史记录 -->
        <div class="history-record-wrapper" v-if="!isSearchBtnEnter">
            <div class="title clearfix">
                历史记录
                <img
                    @click.stop="clearHistoryRecord"
                    :src="searchDustbinIconSrc"
                    alt="delete-icon"
                    class="delete fr"
                >
            </div>
            <div class="history-record-content" v-if="historyRecord">
                <div
                    class="each-tag"
                    v-for="(item,index) of historyRecord"
                    :key="index"
                    v-text="item"
                    @click.stop="searchKeywords(item)"
                ></div>
            </div>
        </div>
        <!-- 搜索结果列表 -->
        <div class="search-result-wrapper" v-else>
            <nav class="top-nav no-scrollbar">
                <div
                    class="each-nav"
                    v-for="(item,index) of resultList"
                    :class="{active:currentNavIndex == index}"
                    @click.stop="navAction(index)"
                    :key="index"
                >{{item.name}}</div>
                <!-- <div class="slider" :style="{left:currentLeft}">
                    <div class="slide"></div>
                </div>-->
                <!-- <div class="slider" :style="{left:currentLeft}"></div> -->
            </nav>
            <div class="no-result" v-if="listData.length === 0 && !!inputKeyword">
                <img :src="nosearchSrc">
                <p>没有搜到哦，试试别的吧~</p>
            </div>
            <div class="search-result-container" v-else>
                <van-pull-refresh
                    v-model="isLoading"
                    @refresh="pullDownRefresh"
                    class="refresh-container"
                >
                    <img slot="loading" :src="loadingSrc" class="boms-loading-sm">
                    <img slot="normal" :src="loadingSrc" class="boms-loading-sm">
                    <img slot="pulling" :src="loadingSrc" class="boms-loading-sm">
                    <img slot="loosing" :src="loadingSrc" class="boms-loading-sm">
                    <van-list v-model="pullUpLoading" :finished="isMaxData" @load="pullUpLoadData">
                        <component
                            :is="currentComName"
                            v-for="item of listData"
                            :key="item.id"
                            :item="item"
                            @click.native="redirectToDetail(item.id)"
                        ></component>
                    </van-list>
                </van-pull-refresh>
            </div>
        </div>
    </div>
</template>

<script>
import ListOfScene from "@/components/ListOfScene";
import ListOfHotel from "@/components/ListOfHotel";
import ListOfGoods from "@/components/ListOfGoods";
import ListOfCar from "@/components/ListOfCar";
import ListOfRoute from "@/components/ListOfRoute";
import ListOfWenChuang from "@/components/ListOfWenChuang";
import ListOfCamping from "@/components/ListOfCamping";
export default {
    name: "SearchResult",
    components: {
        ListOfScene,
        ListOfHotel,
        ListOfCar,
        ListOfGoods,
        ListOfRoute,
        ListOfWenChuang,
        ListOfCamping
    },
    props: {},
    data() {
        return {
            inputKeyword: "",
            currentNavIndex: 0,
            isLoading: false,
            pullUpLoading: false,
            isMaxData: false,
            currentPage: 0,
            numberInEachPage: 10,
            currentResult: 0,
            compName: ["scene", "hotel", "route", "car", "goods", "wen-chuang","camping"],
            isSearchBtnEnter: false,
            historyRecord: null,
            listData: [],
            adjustHeight: 0,
            resultList: [
                {
                    name: "景区",
                    type: 1
                },
                {
                    name: "酒店",
                    type: 2
                },
                {
                    name: "线路",
                    type: 5
                },
                {
                    name: "租车",
                    type: 6
                },
                {
                    name: "特产",
                    type: 8
                },
                {
                    name: "文创",
                    type: 7
                },
                {
                    name: "露营",
                    type: 11
                }
            ],
            searchDustbinIconSrc: "",
            nosearchSrc: "",
            loadingSrc: ""
        };
    },
    computed: {
        currentLeft() {
            // return  0.4 + this.currentNavIndex * 1.653333 + "rem";
            //  return 0.4 + ( this.currentNavIndex * window.innerWidth) / 6 + "px";
        },
        currentComName() {
            return "list-of-" + this.compName[this.currentNavIndex];
        }
    },
    watch: {},
    created() {
        this.adjustHeight = window.innerHeight - 110;
        if (localStorage["history-record"]) {
            this.historyRecord = JSON.parse(localStorage["history-record"]);
        } else {
            this.historyRecord = [];
        }
    },
    mounted() {
        this.searchDustbinIconSrc =
            API.ossUrl + "home/png/search-dustbin-icon.png";
        this.nosearchSrc = API.ossUrl + "common/empty_icons/nosearch.png";
        this.loadingSrc = API.ossUrl + "yyq/loading.gif";
    },
    destroyed() {},
    methods: {
        searchKeywords(historyKeyword) {
            this.currentResult = 0;
            if (historyKeyword) {
                this.inputKeyword = historyKeyword;
            }
            if (this.inputKeyword.trim() === "") {
                this.isSearchBtnEnter = false;
                return;
            }
            this.pullDownRefresh("recursion", 1);
            this.setHistoryRecord(this.inputKeyword);
            this.isSearchBtnEnter = true;
        },
        // onDeleteInput(){
        //     if(this.inputKeyword === '') this.isSearchBtnEnter = false;
        // },
        navAction(index) {
            if (this.inputKeyword == "") {
                this.$toast("请输入搜索关键字,然后切换！");
                return;
            }
            this.listData = [];
            this.currentResult = index;
            this.currentNavIndex = index;
            this.pullDownRefresh();
        },
        searchCancel() {
            document.querySelector(".search-wrapper-real").style.display =
                "none";
            this.$emit("show:footer");
            this.isSearchBtnEnter = false;
        },
        clearHistoryRecord() {
            localStorage.removeItem("history-record");
            this.historyRecord = [];
        },
        setHistoryRecord(key) {
            let tmpHistory = localStorage["history-record"];
            let resolvedArr;
            if (tmpHistory) {
                // let parsedArr = JSON.parse(tmpHistory);
                // parsedArr.unshift(key);
                resolvedArr = [...new Set([key, ...JSON.parse(tmpHistory)])];
            } else {
                resolvedArr = [key];
            }
            this.historyRecord =
                resolvedArr.length > 10
                    ? resolvedArr.slice(0, 10)
                    : resolvedArr;
            localStorage.setItem("history-record", JSON.stringify(this.historyRecord));
        },
        //type:1 scene 2 hotel 3 food 4 goods
        getDataFromPage(number = 1, type = 1) {
            let vm = this;
            return this.$axios.get(
                `${API.search}/${this.inputKeyword}/${type}/${number}/${
                    this.numberInEachPage
                }`
            );
        },
        //下拉刷新
        pullDownRefresh(flag, otherType) {
            /**
             * 当flag存在时 通过flag存在来开启递归查询 类型为otherType参数
             * 会顺序依次发送请求四个模块的列表
             * 直到list中有数据或四次查询均无数据为止
             * 根据业务需要 暂时只在用户点击搜索按钮时才按照递归方式查询
             */
            let vm = this;
            // let type = +this.currentNavIndex + 1;
            let type = this.resultList[this.currentResult].type;
            this.getDataFromPage(1, flag === "recursion" ? otherType : type)
                .then(({ data }) => {
                    if (data.code == 200) {
                        let res = data.data;
                        if (
                            Array.isArray(res.list) &&
                            res.list.length > 0
                        ) {
                            res.list.forEach(e => {
                                if (e.level > 0 && type == 1) {
                                    e.tags.unshift(e.level + "A级");
                                }
                                if (e.level > 0 && type == 2) {
                                    let levelArr = ["一", "二", "三", "四", "五", "六", "七"];
                                    let levelTemp = levelArr[e.level-1] + "星级";
                                    e.tags.unshift(levelTemp);
								}
                                if (e.address) {
                                    e.detailAddress = e.address;
                                    if (
                                        e.address.includes("省") &&
                                        e.address.includes("市")
                                    ) {
                                        e.city = e.address.substr(
                                            e.address.indexOf("省") + 1,
                                            e.address.indexOf("市") -
                                                e.address.indexOf("省") -
                                                1
                                        );
                                    }
                                }
                            });
                        }
                        vm.listData = res.list;
                        vm.isLoading = false;
                        vm.pullUpLoading = false;
                        vm.currentPage = 1;
                        vm.isMaxData = res.pageNo >= res.pageCount;
                        vm.$nextTick(vm.hiddenTag);
                        if (
                            Array.isArray(vm.listData) &&
                            vm.listData.length == 0 &&
                            flag === "recursion"
                        ) {
                            if (vm.currentResult == 6) {
                                vm.currentResult = 0;
                                return;
                            }
                            vm.pullDownRefresh(
                                "recursion",
                                vm.resultList[++vm.currentResult].type
                            );
                            return;
                        }
                        

                        if (flag === "recursion") {
                            vm.currentNavIndex = vm.currentResult;
                        }
                    } else {
                        if (data.code === -1) {
                            if (flag === "recursion") {
                                if (vm.currentResult == 6) {
                                    vm.currentResult = 0;
                                    return;
                                }
                                vm.pullDownRefresh(
                                    "recursion",
                                    vm.resultList[++vm.currentResult].type
                                );
                                return;
                            } else {
                                vm.listData = [];
                            }
                        }
                    }
                })
                .catch(err => console.log(err));
        },
        //上拉加载
        pullUpLoadData(number) {
            let vm = this;
            this.getDataFromPage(
                vm.currentPage + 1,
                this.resultList[this.currentNavIndex].type
            )
                .then(({ data }) => {
                    if (data.code == 200) {
                        let res = data.data;
                        if (
                            Array.isArray(res.list) &&
                            res.list.length > 0
                        ) {
                            res.list.forEach(e => {
                                if (e.level > 0 && this.resultList[this.currentNavIndex].type == 1) {
                                    e.tags.unshift(e.level + "A级");
                                }
                                if (e.level > 0 && this.resultList[this.currentNavIndex].type == 2) {
                                    let levelArr = ["一", "二", "三", "四", "五", "六", "七"];
                                    let levelTemp = levelArr[e.level-1] + "星级";
                                    e.tags.unshift(levelTemp);
								}
                                if (e.address) {
                                    e.detailAddress = e.address;
                                    if (
                                        e.address.includes("省") &&
                                        e.address.includes("市")
                                    ) {
                                        e.city = e.address.substr(
                                            e.address.indexOf("省") + 1,
                                            e.address.indexOf("市") -
                                                e.address.indexOf("省") -
                                                1
                                        );
                                    }
                                }
                            });
                        }
                        vm.listData = vm.listData.concat(res.list);
                        vm.pullUpLoading = false;
                        vm.currentPage = Number(res.pageNo);
                        vm.isMaxData = res.pageNo >= res.pageCount;
                        vm.$nextTick(vm.hiddenTag);
                    } else {
                        if (data.msg === "暂无数据") {
                            vm.listData = [];
                        }
                    }
                })
                .catch(err => console.log(err));
        },
        hiddenTag() {
            let tagArray = [...document.querySelectorAll(".tag")];
            let cw = document.body.clientWidth - 15;
            tagArray.forEach(element => {
                if (element.getBoundingClientRect().right > cw) {
                    element.style.visibility = "hidden";
                }
            });
        },
        redirectToDetail(id) {
            switch (this.resultList[this.currentNavIndex].type) {
                case 1:
                    this.$router.push({
                        name: "sceneDetail",
                        params: { sceneId: id }
                    });
                    break;
                case 2:
                    this.$router.push({
                        name: "hotelDetail",
                        params: { hotelId: id }
                    });
                    break;
                case 5:
                    this.$router.push({
                        name: "routeDetail",
                        params: { routeId: id }
                    });
                    break;
                case 6:
                    this.$router.push({
                        name: "carDetail",
                        params: { carId: id }
                    });
                    break;
                case 7:
                    this.$router.push({
                        name: "wenChuangDetail",
                        params: { wenChuangId: id }
                    });
                    break;
                case 8:
                    this.$router.push({
                        name: "goodsDetail",
                        params: { goodsId: id }
                    });
                    break;
                case 11:
                    this.$router.push({
                        name: "campingDetail",
                        params: { campingId: id }
                    });
                    break;
                default:
                    break;
            }
        }
    }
};
</script>

<style scoped lang="scss">
.search-wrapper-real /deep/ {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1005;
    background: $white;
    .van-search {
        background: $white !important;
        padding: 0.266667rem 0.4rem;
        .van-cell {
            width: 7.866667rem;
            height: 0.96rem;
            background: rgba(244, 244, 244, 1);
            border-radius: 0.48rem;
            .van-cell__left-icon {
                line-height: 0.76rem;
            }
            .van-field__body {
                input::-webkit-input-placeholder {
                    color: #666666 !important;
                    font-weight: 500;
                }
            }
        }
    }
    .van-search--show-action {
        padding-right: 0px;
    }
    .van-field__control {
        font-size: 14px;
    }
    .van-search__action {
        font-size: 14px;
        color: #f8b356;
        font-weight: bold;
        max-width: 2.6667rem;
        min-width: 2.1333rem;
    }
    .van-search__content {
        border-radius: 0.48rem;
    }
}
.history-record-wrapper {
    .title {
        font-size: 16px;
        font-weight: bold;
        color: #444444;
        padding: 0.666667rem 0.853333rem 0.266667rem 0.426667rem;
        .delete {
            width: 0.4rem;
            height: 0.4rem;
        }
    }
    .history-record-content {
        display: flex;
        flex-wrap: wrap;
        padding: 0 0.4rem;
        .each-tag {
            padding: 0.24rem 0.293333rem;
            background: rgba(244, 244, 244, 1);
            border-radius: 0.5333rem;
            color: $black;
            font-size: 15px;
            margin-right: 0.293333rem;
            border-radius: 5px;
            margin-bottom: 0.26rem;
        }
    }
}
.search-result-wrapper {
    .top-nav {
        display: flex;
        width: 100%;
        background: $white;
        z-index: 100;
        position: fixed;
        top: 1.333333rem;
        left: 0;
        overflow-x: scroll;
        margin-right: 0.533333rem;
        .each-nav {
            flex-shrink: 0;
            text-align: center;
            height: 42px;
            margin: 0 0.4rem;
            font-size: 16px;
            color: $grey5;
            transition: 0.2s;
            display: flex;
            justify-content: center;
            align-items: center;
            &.active {
                color: $grey5;
                font-weight: bold;
                position: relative;
                padding-top: 0.053333rem;
                border-bottom: 0.08rem solid #f0bb1b;
            }
        }
        .slider {
            width: 16.7%;
            position: absolute;
            bottom: 6px;
            left: 0.4rem;
            transition: 0.15s ease-in-out;
            .slide {
                width: 1rem;
                height: 3px;
                margin: 0 auto;
                background: #f0bb1b;
                box-shadow: 0px 0px 8px 0px rgba(241, 188, 0, 0.6);
            }
        }
    }
    .search-result-container {
        padding: 0 0.533333rem;
        margin-top: 1.333333rem;
        height: calc(100vh - 110px);
        overflow-y: auto;
    }
    .no-result {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin-top: 42%;
        img {
            width: 6.613333rem;
            height: 5.906667rem;
        }
        p {
            color: #444444;
            font-size: 0.373333rem;
            text-align: center;
            font-weight: bold;
        }
    }
}
</style>

